<template>
    <img
        v-if="imageIsClicked === false"
        :src="src"
        :alt="alt"
        :id="id"
        data-is-clickable
        @click="onMainImageClick"
        @dragstart="onDragStart"
        @touchstart="onDragStart"
    />
    <dialog 
        v-else
        ref="image-dialog"
        @click="onDialogClick"
        @close="onDialogClose"
    >
        <img
            :src="src"
            :alt="alt"
        />
    </dialog>
</template>

<script>
export default {
    name: `zoom-image`,
    data(){
        return {
            imageIsClicked: false
        }
    }, 
    props: {
        src: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true,
        },
        alt: {
            type: String
        },
        showPopupOnClick: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onMainImageClick(e) {
            this.$emit('element-clicked', e);

            if(this.showPopupOnClick === false) return;

            this.imageIsClicked = true;

            this.$emit('element-clicked', e);

            this.$nextTick(() => {
                this.$refs['image-dialog'].showModal();
            });
        },
        onDialogClose(e){
            this.imageIsClicked = false;
            e.target.close();
        },
        onDialogClick: function (e) {
            if (e.target.localName === 'dialog') {
                this.imageIsClicked = false;
                e.target.close();
            }
        },
        onDragStart: function(e){
            this.$emit('dragStart', e);
        }
    }
}
</script>

<style lang="scss" scoped>
[data-is-clickable] {
    max-width: 100%;
}
</style>